<img [height]="diameter" [width]="diameter" [defaultImage]="defaultSvgUri(uid)" [lazyLoad]="getSrc(uid) ? getSrc(uid) : defaultSvgUri(uid)" [errorImage]="defaultSvgUri(uid)">
